/**
 * Application configuration
 */

// Google Sheets configuration
export const googleSheets = {
  // The ID of the Google Sheet (from the URL)
  oddsSheetId: '1Lr5pWGn_4IphN5o4LCfMxmBV1Ttz3ung73DrIJ2uWOs',
  
  // The GID of the specific sheet tab (from the URL after #gid=)
  // Default is '0' for the first sheet
  oddsSheetGid: '0',
  
  // Set to true to use Google Sheets for odds data, false to use local CSV
  // Note: The UI toggle has been removed, but this setting still controls the data source
  useGoogleSheetsForOdds: true
};

// API configuration
export const api = {
  baseUrl: process.env.REACT_APP_API_URL || '',
};

// Feature flags
export const features = {
  enableDebugMode: process.env.NODE_ENV === 'development',
  showExperimentalFeatures: false
}; 